module.exports = __webpack_public_path__ + "static/media/heart.e25873a9.svg";